/**
 * Constructs the full name from a user object.
 * @param {Object} currentUser - The user object with firstName and lastName.
 * @param {string} separator - The separator between first and last name.
 * @returns {string} The full name.
 */
export const fullName = (currentUser, separator) =>
  `${currentUser.firstName}${separator} ${currentUser.lastName}`;

/**
 * Constructs the full address string including postal code.
 * @param {Object} address - The address object with street, postalCode, and city.
 * @returns {string|undefined} The full address or undefined if address is falsy.
 */
export const fullAddress = (address) => {
  if (!address) return undefined;

  const parts = [address.street, address.postalCode, address.city].filter(
    Boolean,
  );
  return parts.join(" · ");
};
